import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { Box, Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import useCloudinary from '../../../hooks/useCloudinaryImage';
import { useDevice } from '../../../hooks/useResponsive';
import VehiclesByCategory from './vehicleList';

export default function CategoryWeb({ category, categoryLoading }) {
  // console.log(category, 'Category1>>>>>>>>>>>');
  const { isMobile } = useDevice();
  const leftRef = useRef(null);

  return (
    <div>
      <Stack className="main-banner" sx={{ py: 10, px: '75px' }}>
        <Stack direction={{ xs: 'column', md: 'row' }} gap={3} alignItems="stretch">
          <Stack
            sx={{
              width: '50%',
              flexShrink: 0,
              height: '100%',

              position: 'sticky',
              top: 20,
              ml: '0 !important',
              alignSelf: 'flex-start',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              py: 2,
            }}
          >
            {isMobile ? (
              <Link to={`/category-single/${category?.category?._id}`} style={{ textDecoration: 'none' }}>
                <Box width={'100%'} mt={2}>
                  {category && category?.category?.appBanners && (
                    <img
                      // src={category?.category?.appBanners[0]?.url}
                      // eslint-disable-next-line react-hooks/rules-of-hooks
                      src={useCloudinary(category?.category?.appBanners[0]?.url, 'w_400 f_auto q_auto')}
                      alt=""
                      width="100%"
                    />
                  )}
                </Box>
              </Link>
            ) : (
              <Link to={`/category-single/${category?.category?._id}`} style={{ textDecoration: 'none' }}>
                {category && category?.category?.webBanners && (
                  <img
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    src={useCloudinary(category?.category?.webBanners[0]?.url, 'w_700 f_auto q_auto')}
                    // src={category?.category?.webBanners[0]?.url}
                    alt=""
                    width={'100%'}
                  />
                )}
              </Link>
            )}
          </Stack>
          {/* Right - Fixed Section */}
          <Stack
            ref={leftRef}
            sx={{
              flex: 1,
              // height: '100%',

              overflowY: 'auto',
              // maxHeight: '100vh',
              width: '50%',
              // scrollbarWidth: 'none',
              // '&::-webkit-scrollbar': {
              //   display: 'none',
              // },
            }}
          >
            <VehiclesByCategory vehicles={category?.vehicles} categoryLoading={categoryLoading} />
            <Box display={'flex'} justifyContent={'center'} sx={{ width: '100%', pt: 2, px: 2 }}>
              <Link
                to={`/category-single/${category?.category?._id}`}
                style={{ textDecoration: 'none', width: '100%', position: 'relative', display: 'block' }}
              >
                <Button
                  sx={{
                    width: '100%',
                    background: 'linear-gradient(90deg, #4E1F07 0%, #6E3518 0%, #8A3E0C 46.78%, #B05809 100%)',
                    backgroundBlendMode: 'soft-light',
                    color: '#e0e0e0',
                    fontSize: '16px',
                    borderRadius: '4px',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: 600,
                    justifyContent: 'center',
                    gap: 1,
                    paddingY: '10px',
                    lineHeight: 1.2,
                    minHeight: 'unset',
                  }}
                >
                  <Typography sx={{ zIndex: 800, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                    View All {category?.category?.name}
                    <ArrowForwardIosIcon sx={{ paddingLeft: '10px' }} />
                  </Typography>
                </Button>
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'linear-gradient(90deg, #222222 0%, rgba(147, 100, 44, 0.5) 50.01%, #222222 100%)',
                    borderRadius: '4px',
                    zIndex: 2,
                    opacity: 0.7, // control how much it covers
                  }}
                />
              </Link>
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </div>
  );
}
CategoryWeb.propTypes = {
  category: PropTypes.object,
  categoryLoading: PropTypes.any,
};
